import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import Cookies from 'js-cookie';
import { PushAnalyticsEvent, syntheticEventHubEvent } from '@/analytics/analyticsUtils';
import { AnalyticsEventName } from '@/analytics/constants';

export const useAnalytics = () => {
  const auth = useAuth();

  const userId =
    (auth?.user?.profile?.IndividualSK as string)?.length > 0
      ? (auth.user?.profile?.IndividualSK as string)
      : '000000';

  const measurementId = import.meta.env.VITE_APP_GA4_MEASUREMENT_ID;
  const cookieName = `_gtm_ga_${measurementId}`;
  let gaCookie = Cookies.get(cookieName) || Cookies.get('_gtm_ga');
  if (!gaCookie || gaCookie === 'deleted') {
    gaCookie = Cookies.get(`_ga_${measurementId}`) || Cookies.get('_ga');
  }
  const sessionId = gaCookie ? `${gaCookie}.${userId}` : 'NoSession';

  const trackEvent = useCallback(
    (event: AnalyticsEventName, eventData: Record<string, unknown> = {}) => {
      PushAnalyticsEvent(event, eventData);

      syntheticEventHubEvent({
        event,
        sessionId,
        ...eventData
      });
    },
    [sessionId]
  );

  return { trackEvent, sessionId, userId };
};
